<template>
	<div class="order page-container">
		<custom-table :pageConfig="pageConfig" :multipleSelection="multipleSelection" :buttonGroup="buttonGroup"
			:filterValue="filterValue" :tableFilter="tableFilter" :tableConfig="tableConfig" :tableData="tableData"
			@pageChange="pageChange" @buttonClick="buttonClick" @filterChange="filterChange"
			@scopeButtonClick="scopeButtonClick">
		</custom-table>
	</div>
</template>

<script>
	export default {
		name: 'order',
		data() {
			return {
				pageConfig: {
					totalWord: '全部数据',
					total: 0,
					pageSize: 13,
					currentPage: 1,
				},
				multipleSelection: [],
				buttonGroup: [],
				filterValue: {},
				tableFilter: [],
				tableConfig: {
					border: true,
					selection: false,
					showOverflowTooltip: true,
					tableHeader: [{
							prop: 'lotOrderId',
							label: '订单编号',
							width: 260
						},
						{
							prop: 'lotName',
							label: '商品名称',
							width: 250
						},
						{
							prop: 'payTime',
							label: '发布时间',
							width: 250
						},
						{
							prop: 'payPrice',
							label: '成交价格',
							width: 100
						},
						{
							prop: 'memberNo',
							label: '购买人',
							width: 280
						}
					],
					tableEvent: [{
						icon: 'el-icon-search',
						name: '查看',
						color: 'blue',
						sign: 'check'
					},
					// {
					// 	icon: 'el-icon-delete',
					// 	name: '删除',
					// 	color: 'red',
					// 	sign: 'delete'
					// }
					],
					emptyDescription: '当前没有数据',
				},
				tableData: []
			};
		},
		methods: {
			// 页面变化
			pageChange() {
				this.fetchData()
			},
			// 右上按钮
			buttonClick(sign) {
				if (sign === 'new') {
					this.$router.push({
						path: '/itemedit'
					})
				}
			},
			// 筛选条件变化
			filterChange() {
				console.log(this.filterValue);
			},
			scopeButtonClick(row, sign){
				if(sign === 'check'){
					this.$router.push({
						path:'/orderDetail',
						query:{
							id: row.lotOrderId
						}
					})
				}
				if(sign === 'delete'){
					this.$confirm('确认删除订单？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.deleteOrder()
					}).catch(() => {});
				}
			},
			deleteOrder(){
				
			},
			fetchData() {
				this.$api.orderList({
					pageSize: this.pageConfig.pageSize,
					pageNum: this.pageConfig.currentPage
				}, res => {
					console.log(res);
					if (res.code == 200) {
						this.pageConfig.total = res.data.total
						this.tableData = res.data.list
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped"></style>
